import { IEmailDomain, IEmailDomainInfo } from "./user.types";

export class EmailDomainInfo implements IEmailDomainInfo {
  readonly emainlDomain: string;
  readonly domains: IEmailDomain[];

  constructor(data: IEmailDomainInfo) {
    this.emainlDomain = data.emainlDomain;
    this.domains = data.domains;
  }
}
